"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatsAppMessageEntitySchema = exports.WhatsAppStatusSchema = void 0;
const zod_1 = require("zod");
const timestamp_schemas_1 = require("./timestamp.schemas");
// ============================================
// INTERNAL SCHEMAS (Entity)
// ============================================
// WhatsApp message status (from whatsapp_messages.status CHECK constraint)
const _WhatsAppStatusSchema = zod_1.z.enum(['sent', 'delivered', 'read', 'failed']);
// WhatsApp message entity schema matching database whatsapp_messages table
const _WhatsAppMessageBaseSchema = zod_1.z.object({
    message_id: zod_1.z.number().int().positive(),
    wa_message_id: zod_1.z.string().max(100).nullable(), // Meta's message ID
    recipient_phone: zod_1.z.string().max(20),
    template_name: zod_1.z.string().max(50),
    status: _WhatsAppStatusSchema,
    reference_type: zod_1.z.string().max(20).nullable(), // varchar(20) in DB, no CHECK
    reference_id: zod_1.z.number().int().positive().nullable(),
    error_message: zod_1.z.string().nullable(),
    sent_at: timestamp_schemas_1.timestampIsoSchema,
    delivered_at: timestamp_schemas_1.timestampIsoSchema.nullable(),
    read_at: timestamp_schemas_1.timestampIsoSchema.nullable(),
});
// ============================================
// ENTITY SCHEMAS (Export Aliases)
// ============================================
exports.WhatsAppStatusSchema = _WhatsAppStatusSchema;
exports.WhatsAppMessageEntitySchema = _WhatsAppMessageBaseSchema;
